module.exports = __webpack_public_path__ + "img/pot.7317c540.svg";